// extracted by mini-css-extract-plugin
export default {"container":"ZwzQvEY7YKeIJBzjKzMa","description":"LXhqXC9e_RFxnry2pbKs","text":"sgOKYwFKipK5YP0LjYKA"};